module.exports = __webpack_public_path__ + "static/media/logoUportSmall.d1ac25e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/graphics/logoUportSmall.png
// module id = 776
// module chunks = 1 3